
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
export default [
  {
    name: "career-employment",
    path: "/karriere/attraktiver-arbeitgeber",
    component: () => import("/home/snaumann/Development/public_html/awo-lausitz/public/app/pages/karriere/attraktiver-arbeitgeber.vue").then((m) => Object.assign(m.default, { __name: "career-employment" }))
  },
  {
    name: "career-jobs",
    path: "/karriere/stellenangebote",
    component: () => import("/home/snaumann/Development/public_html/awo-lausitz/public/app/pages/karriere/stellenangebote.vue").then((m) => Object.assign(m.default, { __name: "career-jobs" }))
  },
  {
    name: "location-detail",
    path: "/einrichtungen/:location_slug()",
    component: () => import("/home/snaumann/Development/public_html/awo-lausitz/public/app/pages/einrichtungen/[location_slug].vue").then((m) => Object.assign(m.default, { __name: "location-detail" }))
  },
  {
    name: "news-list",
    path: "/aktuelles",
    component: () => import("/home/snaumann/Development/public_html/awo-lausitz/public/app/pages/aktuelles/index.vue").then((m) => Object.assign(m.default, { __name: "news-list" }))
  },
  {
    name: "career-index",
    path: "/karriere",
    component: () => import("/home/snaumann/Development/public_html/awo-lausitz/public/app/pages/karriere/index.vue").then((m) => Object.assign(m.default, { __name: "career-index" }))
  },
  {
    name: "article-detail",
    path: "/:article_slug()",
    component: () => import("/home/snaumann/Development/public_html/awo-lausitz/public/app/pages/[article_slug].vue").then((m) => Object.assign(m.default, { __name: "article-detail" }))
  },
  {
    name: "home",
    path: "/",
    component: () => import("/home/snaumann/Development/public_html/awo-lausitz/public/app/pages/index.vue").then((m) => Object.assign(m.default, { __name: "home" }))
  }
]